module.exports = __webpack_public_path__ + "static/901-f2e7f27dd592a7e2fdc7601f25aa2511.png";